// extracted by mini-css-extract-plugin
export var card = "_a6-0";
export var expandedCard = "_a6-2";
export var paginated = "_a6-1";